module.exports = __webpack_public_path__ + "4461e0144a346276300437a51d0a7cdf.png";